module.exports = "https://static.wmbcdn.com/uniweb/images/c78a96ed7414b8ea662c3650f740a983.svg";